import * as angular from 'angular';
import {ibUiCommunityListByCountryService} from './service/ib-ui-community-list-by-country-service';

@Component('ib-ui-community-list-by-country-module', 'ibUiCommunityListByCountry', {
    bindings: {
        containerForm: '<',
        communitySelected: '=',
        statesLiteral: '<',
        country: '<',
        editionMode: '<',
        isRequired: '<?'
    },
    controllerAs: 'ibUiCommunityListByCountryCtrl',
    templateUrl: ['$rootScope', ($rootScope) => {
        return `${$rootScope.routes.templates}ib-ui-community-list-by-country-view.html`;
    }]
}, ['ibUiCommunityListByCountryService', '$timeout'], [])

class ibUiCommunityListByCountry implements ng.IController {

    public communitiesList = [];
    public statesLiteral: string;
    public country: string;
    public showRegion: boolean;
    public communitySelected: any;
    constructor (private ibUiCommunityListByCountryService: ibUiCommunityListByCountryService, private $timeout: ng.ITimeoutService) {
        this.communitiesList = [];
        this.statesLiteral;
        this.showRegion = false;
    }

    ////////////////

    initCommunityListByCountry = (statesLiteral: string, country: string): void => {
        if (statesLiteral === 'REGION') {
            this.showRegion = true;
        } else {
            this.communitiesList = [];
            this.ibUiCommunityListByCountryService.initializeCommunityListByCountry(statesLiteral ? statesLiteral : 'PROVINCE_FIELD', country ? country : 'ES').then(
                (response) => {
                    this.showRegion = false;
                    this.communitiesList = angular.copy(response);
                    this.communitySelected = this.communitiesList.filter(item => item.description === this.communitySelected.description)[0];
                },
                (error) => {
                    
                }
            );
        }
    };

    $onInit () {
        if (this.statesLiteral) this.ibUiCommunityListByCountryService.setFormInterfaces(this.initCommunityListByCountry);
        this.initCommunityListByCountry(this.statesLiteral, this.country);
    }
}